import { useTranslation } from 'react-i18next'
import { notEquippedUsageUnitAppointmentTypeValueGetter } from '../valueGetter'

const NotEquippedUsageUnitAppointmentTypeRenderer = (props) => {
  const { t } = useTranslation()
  return t(notEquippedUsageUnitAppointmentTypeValueGetter(props))
}

export default NotEquippedUsageUnitAppointmentTypeRenderer
